import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { hashCodeOf2bangq6jexew2 as hashCodeOf } from './AnyX.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ErrorMessage$Companion$blankString$delegate$lambda() {
  return new (ErrorMessage())("Given string shouldn't be blank.");
}
function ErrorMessage$Companion$_get_blankString_$ref_u1k14y() {
  return (p0) => p0.z28();
}
function ErrorMessage$Companion$emptyCollection$delegate$lambda() {
  return new (ErrorMessage())("Given collection shouldn't be empty.");
}
function ErrorMessage$Companion$_get_emptyCollection_$ref_5o3pl4() {
  return (p0) => p0.a29();
}
function ErrorMessage$Companion$emptyMap$delegate$lambda() {
  return new (ErrorMessage())("Given map shouldn't be empty.");
}
function ErrorMessage$Companion$zeroNumber$delegate$lambda() {
  return new (ErrorMessage())('Number should be other than zero');
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        tmp.v28_1 = lazy(ErrorMessage$Companion$blankString$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w28_1 = lazy(ErrorMessage$Companion$emptyCollection$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x28_1 = lazy(ErrorMessage$Companion$emptyMap$delegate$lambda);
        var tmp_2 = this;
        tmp_2.y28_1 = lazy(ErrorMessage$Companion$zeroNumber$delegate$lambda);
      }
      z28() {
        var tmp0 = this.v28_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('blankString', 1, tmp, ErrorMessage$Companion$_get_blankString_$ref_u1k14y(), null);
        return tmp0.s3();
      }
      a29() {
        var tmp0 = this.w28_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('emptyCollection', 1, tmp, ErrorMessage$Companion$_get_emptyCollection_$ref_5o3pl4(), null);
        return tmp0.s3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ErrorMessageClass;
function ErrorMessage() {
  if (ErrorMessageClass === VOID) {
    class $ {
      constructor(text) {
        Companion_getInstance();
        this.b29_1 = text;
        // Inline function 'kotlin.text.isNotBlank' call
        var this_0 = this.b29_1;
        var isValid = !isBlank(this_0);
        // Inline function 'kotlin.require' call
        if (!isValid) {
          var message = "Error message shouldn't be blank";
          throw IllegalArgumentException().s2(toString(message));
        }
      }
      equals(other) {
        var tmp;
        if (other instanceof ErrorMessage()) {
          tmp = this.b29_1 === other.b29_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCodeOf(this.b29_1, []);
      }
      toString() {
        return this.b29_1;
      }
    }
    initMetadataForClass($, 'ErrorMessage');
    ErrorMessageClass = $;
  }
  return ErrorMessageClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstancerlx10hnidx57,
};
//endregion

//# sourceMappingURL=ErrorMessage.mjs.map
